import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import type { DataGridContextMenuProps } from "src/components/DataGrid/useDataGridRowContextMenu.tsx";
import { useSnackbar } from "src/App/App.hooks.ts";
import { useMutation } from "@tanstack/react-query";
import { getExonnApi } from "src/exonn-api/exonn-api.tsx";
import { download } from "@exonn/utils";

export const useVoucherSerieListContextMenu = ({
  selectedRow,
}: {
  selectedRow?: GridValidRowModel;
}): {
  items: DataGridContextMenuProps<GridValidRowModel>["items"];
  isPending: boolean;
} => {
  const snackbar = useSnackbar();
  const { isPending, mutate: exportVouchers } = useMutation({
    mutationFn: async ({ row }: { row: GridValidRowModel }) => {
      const api = getExonnApi();
      const response = await api.voucherSerie.exportVouchers(
        {
          id: row.id,
        },
        null,
        {
          responseType: "blob",
        },
      );

      if (response.data) {
        download(response.data, `vouchers_${row.id}.csv`);
      }
    },
  });

  const handleExport = (row: GridValidRowModel) => {
    exportVouchers(
      {
        row,
      },
      {
        onError: () => {
          snackbar.error({
            message: "Couldn't export vouchers",
            flash: true,
          });
        },
        onSuccess: () => {
          snackbar.success({
            message: "Vouchers have been successfully exported",
            flash: true,
          });
        },
      },
    );
  };

  return {
    isPending,
    items: selectedRow
      ? [
          {
            key: "export",
            label: "Export",
            icon: <span className={"icon-15-export"} />,
            onSelect: handleExport,
          },
        ]
      : [],
  };
};
